import { gql } from '@apollo/client'

import { apolloClient } from '@/components/AuthApolloProvider'

export function useAccountUrl() {
  const data = apolloClient.readQuery({
    query: gql`
      query GetAccountUrl {
        accountUrl @client
      }
    `
  })

  return data?.accountUrl
}
